import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.0001 16.0011C16.0001 14.0214 15.6102 12.0611 14.8526 10.2321C14.095 8.40301 12.9846 6.74113 11.5847 5.34125C10.1849 3.94138 8.52292 2.83093 6.6939 2.07332C4.86487 1.31572 2.90453 0.925781 0.924805 0.925781L0.924805 16.0011H16.0001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 16.0011C16 14.0214 16.3899 12.0611 17.1475 10.2321C17.9051 8.40301 19.0155 6.74113 20.4155 5.34125C21.8153 3.94138 23.4772 2.83093 25.3063 2.07332C27.1353 1.31572 29.0956 0.925781 31.0753 0.925781V16.0011H16Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.924805 16C0.924805 17.9797 1.31474 19.9401 2.07235 21.7691C2.82995 23.5981 3.9404 25.26 5.34028 26.6599C6.74015 28.0598 8.40203 29.1702 10.2311 29.9278C12.0601 30.6855 14.0204 31.0754 16.0001 31.0754V16H0.924805Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31.0753 16C31.0753 17.9797 30.6854 19.9401 29.9278 21.7691C29.1702 23.5981 28.0597 25.26 26.6599 26.6599C25.26 28.0598 23.5981 29.1702 21.7691 29.9278C19.94 30.6855 17.9797 31.0754 16 31.0754V16H31.0753Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }